// extracted by mini-css-extract-plugin
export default {"detailsContainer":"DetailsInput_detailsContainer__Cssza"};